<template>
  <div id="main">
    <br />
    <label style="font-size:40px;">
      No show
    </label>
    
    <article class="message">
      <div class="message-body">
        <div class="columns">
          <div class="column is-2" style="padding: 1em 1em 0 1em;"> 
            Fecha actual
            <br>
            <date-pick v-model="fecha"></date-pick>
          </div>
          <!-- <div class="column is-2" style="padding: 1em 1em 0 2em;">
            Hasta <br>
            <date-pick  v-model="fechaFinal"></date-pick>
          </div> -->
          <div class="column is-3" style="padding: 1em 1em 0 3em;" >
            <br>
            <a @click="setFecha()" class="button is-info is-small">Mostrar No Shows</a>
            <!-- <a class="button is-warning is-small" @click="setRange">Establecer</a> -->
          </div>
          <div class="column is-2">
          </div>
          <div class="column is-2" align="right"> <br>
            <input class="input is-small" v-model="searchText" placeholder="Buscar por nombre ...">
          </div>
          <!-- <div class="column is-1" align="right"> <br>
            <a class="button is-small is-success" @click="tableToExcel('testTable', 'W3C Example Table')"> Exportar a Excel </a>
          </div> -->
        </div>
      </div>
    </article>

    <br>
    <!-- No riviera -->
    <p>RESERVACIONES DE 1 DÍA</p>
    <div align="center" v-if="this.reservacionesConfirmadas.length>0">
        <a class="button is-success is-rounded" @click="confirmarReservaciones" style="position:fixed; z-index: 2;" >Confirmar {{this.reservacionesConfirmadas.length}} </a><br><br>
        ___<a class="button is-danger is-rounded" @click="reservacionesConfirmadas=[]" style="position:fixed; z-index: 2;" >Cancelar</a>
    </div>
    <span v-if="toursReservados=='no hay datos'" v-text="'SIN RESERVACIONES'" ></span>
    <template v-for="tour in toursReservados" v-if="toursReservados!=='no hay datos'">
      <table style="z-index: -9; width:100%;" class="table is-bordered is-hoverable" id="testTable" :key="tour.id">
        <thead>
          <tr><th></th><th class="tituloHotel is-size-7" colspan="8">{{tour.nombre}} ({{tour.id}})</th></tr>
          <tr>
            <th></th>
            <th class="is-size-7">USER</th>
            <th class="is-size-7">HOTEL</th>
            <th class="is-size-7">VENDEDOR</th>
            <th class="is-size-7" >CLIENTE</th>
            <th class="is-size-7" >HAB</th>
            <th class="is-size-7" style="width:100px!important;"><font color="white">_____</font>PAX<font color="white">_____</font></th>
            <th class="is-size-7">HORA</th>
            <th class="is-size-7">FECHA</th>
            <th class="is-size-7" ><font color="white">___________</font>TOUR<font color="white">___________</font></th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(reserva,index) in itemsSearched" :key="reserva.id" v-if="reserva.tourId==tour.id">
            <!-- <td class="is-size-7"> <a class="button is-small is-danger" @click="cancelar(index)">Cancelar</a> </td> -->
            <td class="is-size-7"> <a class="button is-small is-info" @click="guardar(index)">Restaurar</a> </td>
            <td class="is-size-7"> {{reserva.usuarioNombre}} </td>
            <td class="is-size-7"> {{reserva.hotelName}} </td>
            <td class="is-size-7"> {{reserva.vendedorNombre}} </td>
            <td class="is-size-7">
              <!-- <label class="checkbox">
                <input v-model="reservacionesConfirmadas" :value="reserva.id" type="checkbox">
              </label> -->
              {{reserva.cliente}} 
            </td>
            <td class="is-size-7"> {{reserva.habitacion}} </td>
            <td class="is-size-7 has-text-centered" style="white-space:nowrap;"> <input class="input is-small" v-model="itemsSearched[index].adultos" style="width: 33%" /><input class="input is-small" v-model="itemsSearched[index].ninos" style="width: 33%" /> <input class="input is-small" v-model="itemsSearched[index].infantes" style="width: 33%" /> </td>
            <td class="is-size-7">  <input style="width:105px!important;" type="time" v-model="itemsSearched[index].pickup" />  </td>
            <td style="width:100px;!important" > <date-pick v-model="itemsSearched[index].fecha"></date-pick> </td>
            <td class="is-size-7" > {{reserva.tour}} {{reserva.tipo}} {{reserva.desde}} {{reserva.nacionalidad}} {{reserva.idioma}} <span v-if="reserva.horario==2" v-text="'2° HORARIO'"></span> - <span v-if="reserva.servicio==2" v-text="'PRIVADO'"></span> <span v-if="reserva.cortesia==1" v-text="'CORTESÍA'"></span>  <span v-if="reserva.tipoReservacionId>1" > Combo ({{reserva.posicionReservacion}}/{{reserva.tipoReservacionId}}) id.{{reserva.id}} </span> </td>
            <!-- <td>
              <div class="select is-small">
                <select v-model="transporteElegido" @click="beforeAsignar(tour.id,'1',reserva.asientos,reserva.id)" >
                  <option>Asignar reservación</option>
                  <option v-for="(transporte,index) in transportesList" :value="transporte" :key="index" v-if=' parseInt(transporte.capacidad)>= reserva.asientos ' >{{transporte.nombre}} - [{{transporte.capacidad}}]</option>
                </select>
              </div>
            </td> -->
          </tr>
          <tr>
            <td colspan="2"></td>
          <!-- <td class="is-size-7" colspan="5">
            <div class="select is-small">
              <select v-model="transporteElegido"  @click="beforeAsignar(tour.id)">
                <option>Asignar todos</option>
                <option v-for="(transporte,index) in transportesList" :key="index" :value="transporte" >{{transporte.nombre}} - [{{transporte.capacidad}}]</option>
              </select>
            </div>
          </td> -->
          <td class="is-size-7 has-text-centered">{{tour.pax}}<span v-if="tour.ninos>0">.{{tour.ninos}}</span><span v-if="tour.infantes>0">.{{tour.infantes}}</span> </td>
          <td>
            </td></tr>
        </tbody>
      </table>
    </template>

    <!--Riviera-->
    <p>RIVIERA MAYA</p>
    <div align="center" v-if="this.reservacionesConfirmadas.length>0">
        <a class="button is-success is-rounded" @click="confirmarReservaciones" style="position:fixed; z-index: 2;" >Confirmar {{this.reservacionesConfirmadas.length}} </a><br><br>
        ___<a class="button is-danger is-rounded" @click="reservacionesConfirmadas=[]" style="position:fixed; z-index: 2;" >Cancelar</a>
    </div>
    <span v-if="toursReservadosRiviera=='no hay datos'" v-text="'SIN RESERVACIONES'" ></span>
    <template v-for="tour in toursReservadosRiviera" v-if="toursReservadosRiviera!=='no hay datos'">
      <table style="z-index: -9; width:100%;" class="table is-bordered is-hoverable" id="testTable" :key="tour.id">
        <thead>
          <tr><th></th><th class="tituloHotel is-size-7" colspan="7">{{tour.nombre}} ({{tour.id}})</th></tr>
          <tr>
            <th></th>
            <!-- <th></th> -->
            <th class="is-size-7">USER</th>
            <th class="is-size-7">HOTEL</th>
            <th class="is-size-7">VENDEDOR</th>
            <th class="is-size-7" >CLIENTE</th>
            <th class="is-size-7" >HAB</th>
            <th class="is-size-7" style="width:100px!important;"><font color="white">_____</font>PAX<font color="white">_____</font></th>
            <th class="is-size-7">HORA</th>
            <th class="is-size-7" ><font color="white">___________</font>TOUR<font color="white">___________</font></th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(reserva,index) in reservacionesRivieraList" :key="reserva.id" v-if="reserva.tourId==tour.id">
            <!-- <td class="is-size-7"> <a class="button is-small is-danger" @click="cancelar(index)">Cancelar</a> </td> -->
            <td class="is-size-7"> <a class="button is-small is-info" @click="guardar(index)">Restaurar</a> </td>
            <td class="is-size-7"> {{reserva.usuarioNombre}} </td>
            <td class="is-size-7"> {{reserva.hotelName}} </td>
            <td class="is-size-7"> {{reserva.vendedorNombre}} </td>
            <td class="is-size-7">
              <!-- <label class="checkbox">
                <input v-model="reservacionesConfirmadas" :value="reserva.id" type="checkbox">
              </label> -->
              {{reserva.cliente}} 
            </td>
            <td class="is-size-7"> {{reserva.habitacion}} </td>
            <td class="is-size-7 has-text-centered" style="white-space:nowrap;"> <input class="input is-small" v-model="itemsSearched[index].adultos" style="width: 33%" /><input class="input is-small" v-model="itemsSearched[index].ninos" style="width: 33%" /> <input class="input is-small" v-model="itemsSearched[index].infantes" style="width: 33%" /> </td>
            <td class="is-size-7">  <input style="width:105px!important;" type="time" v-model="itemsSearched[index].pickup" />  </td>
            <td class="is-size-7"> {{reserva.tour}} {{reserva.tipo}} {{reserva.desde}} {{reserva.nacionalidad}} {{reserva.idioma}} <span v-if="reserva.horario==2" v-text="'2° HORARIO'"></span> - <span v-if="reserva.servicio==2" v-text="'PRIVADO'"></span> <span v-if="reserva.cortesia==1" v-text="'CORTESÍA'"></span>  <span v-if="reserva.tipoReservacionId>1" > Combo ({{reserva.posicionReservacion}}/{{reserva.tipoReservacionId}}) id.{{reserva.id}} </span> </td>
            <!-- <td>
              <div class="select is-small">
                <select v-model="transporteElegido" @click="beforeAsignar(tour.id,'1',reserva.asientos,reserva.id)" >
                  <option>Asignar reservación</option>
                  <option v-for="(transporte,index) in transportesList" :value="transporte" :key="index" v-if=' parseInt(transporte.capacidad)>= reserva.asientos ' >{{transporte.nombre}} - [{{transporte.capacidad}}]</option>
                </select>
              </div>
            </td> -->
          </tr>
          <tr>
            <td></td>
          <td class="is-size-7" colspan="6">
          </td>
          <td class="is-size-7 has-text-centered">{{tour.pax}}<span v-if="tour.ninos>0">.{{tour.ninos}}</span><span v-if="tour.infantes>0">.{{tour.infantes}}</span> </td>
          <td>
            </td></tr>
        </tbody>
      </table>
    </template>
    <!--Ends riviera-->

  </div>
</template>

<script src="../toexcel.js" type="text/javascript"></script>
<script>
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import axios from 'axios';
import Cors from 'cors';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
require('../mixins/mixin.js');

import Vue from 'vue'
import {
  VTooltip
} from 'v-tooltip'
import { Script } from 'vm';
Vue.use(VTooltip)


Vue.directive('tooltip', VTooltip)

export default {
  components:{
    DatePick,
    VueClockPicker
  },
  data() {
    return {
      reservacionesList:[],
      reservacionesRivieraList:[],
      hotelesReservados:[],
      toursReservados:[],
      toursReservadosRiviera:[],
      transportesList:[],
      idsToUpdate:[],
      idsList:[],
      transporteElegido:'',
      fecha:moment().format('YYYY-MM-DD'),
      restar:'',
      transportesReservados:[],
      reservacionesAsignadasList:[],
      monedasList:[],
      dia: moment(this.fecha).add(1, 'day').format('dddd'),

      loaded: false,
      userDep: $cookies.get('RhSession').id_depar,
      fechaInicial: '',
      fechaFinal: '',
      colaboradoresList: [],
      incidencia_tipo: [],
      idsColaboradores: [],
      datesInterval: [],
      incidenciasList: {},
      incidencias:{},
      commentStyle: {
        borderStyle: true
      },
      showIncidenceTable: '',
      tipoId:'',
      tipoNombre:'',
      id:'',
      key:'',
      colaborador:'',
      comentarioIncidencia:'',
      searchText:'',
      host: 'booking.sistemy.mx',
      // host: 'localhost',
      hotelesReservadosRiviera:[],
      hotelesReservadosCombos:[],
      reservacionesConfirmadas:[],

      menuComponente: 'app-create',
    }
  },
  created() {
    this.getMonedas()
    this.toursConReservas()
    this.toursConReservasRiviera()
    this.reservaciones()
    this.reservacionesRiviera()
    this.getTransportes()
  },
  computed: {
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.reservacionesList;
      }
      return self.reservacionesList.filter(function(item){
        var str = self.searchText;
        var res = str.toUpperCase();
        return item.cliente.includes(str);
      });
    } 
  },
  methods: {
    setFecha () {
      console.log("setFecha");
      this.toursConReservas()
      this.toursConReservasRiviera()
      this.reservaciones()
      this.reservacionesRiviera()
      this.reservacionesAsignadas()
      this.getTransportes()
      this.transportesConReservas()
    },
    sumar (a,b) {
      return a+b;
    },
    guardar (index) {
      console.log("guardando cambios");
      console.log(this.reservacionesList[index].adultos,'adultos');
      console.log(this.reservacionesList[index].id,"id");
      console.log(this.itemsSearched[index].balance,'balance');
      // axios.post('http://localhost:3000/justUpdate',{
      //       table:"reservaciones",
      //       set:" adultos = "+this.itemsSearched[index].adultos+", ninos = "+this.itemsSearched[index].ninos+", infantes = "+this.itemsSearched[index].infantes+", balance = "+this.itemsSearched[index].balance+", moneda = "+this.itemsSearched[index].moneda+", observaciones = '"+this.itemsSearched[index].observaciones+"' ",
      //       where:"id="+this.itemsSearched[index].id
      //     })
      var tabla = `reservaciones`;
      var set = " activo=1, fecha = '"+this.itemsSearched[index].fecha+"', adultos = "+this.itemsSearched[index].adultos+", ninos = "+this.itemsSearched[index].ninos+", infantes = "+this.itemsSearched[index].infantes+", balance = "+this.itemsSearched[index].balance+", moneda = "+this.itemsSearched[index].moneda+", observaciones = '"+this.itemsSearched[index].observaciones+"'";
      var where = "id="+this.itemsSearched[index].id;
      axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              this.$snotify.success('Cambios guardados', 'Correcto', {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
            }else{
              console.log('error');
            }
          });
    },
    getMonedas(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
          }else{
            console.log('error');
          }
        });
    },
    reservaciones () {
      console.log(this.fecha,'fecha');
      var select = `tour.nombre as tour,
          hoteles.nombre as hotelName,
          reservaciones.adultos%2Breservaciones.ninos as asientos,
          tipo.nombre as tipo,
          lugar_salida.nombre as desde,
          nacionalidad.nombre as naciondalidad,
          idioma.nombre as idioma,
          reservaciones.*,
          vendedores.nombre as vendedorNombre,
          usuarios.nombre as usuarioNombre,
          monedas.nombre as monedaNombre`;
      var tabla = 'reservaciones, tour, tipo, lugar_salida, nacionalidad, idioma, vendedores, usuarios, monedas, hoteles';
      var where = 'reservaciones.salidaId=1 and reservaciones.hotelId=hoteles.id and reservaciones.vendedorId=vendedores.id and reservaciones.usuarioIdCreado=usuarios.id and reservaciones.moneda=monedas.id and reservaciones.tourId=tour.id and reservaciones.tipoTourId=tipo.id and reservaciones.salidaId=lugar_salida.id and reservaciones.nacionalidadId=nacionalidad.id and reservaciones.idiomaId=idioma.id and reservaciones.transporteRegresoId is null and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'" order by reservaciones.cliente ';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
       .then((response)=>{
         if (response.status == 200 ) { console.log("bien jean");
            console.log(response.data,'<-- response php server');
            this.reservacionesList = response.data;
            this.itemsSearched = response.data;
         }else{
           console.log('error: No reservado');
         }
       });
    },
    reservacionesRiviera () {
      console.log(this.fecha,'fecha');
      var select = `tour.nombre as tour,
          hoteles.nombre as hotelName,
          reservaciones.adultos%2Breservaciones.ninos as asientos,
          tipo.nombre as tipo,
          lugar_salida.nombre as desde,
          nacionalidad.nombre as naciondalidad,
          idioma.nombre as idioma,
          reservaciones.*,
          vendedores.nombre as vendedorNombre,
          usuarios.nombre as usuarioNombre,
          monedas.nombre as monedaNombre`;
      var tabla = 'reservaciones, tour, tipo, lugar_salida, nacionalidad, idioma, vendedores, usuarios, monedas, hoteles';
      var where = 'reservaciones.salidaId>1 and reservaciones.hotelId=hoteles.id and reservaciones.vendedorId=vendedores.id and reservaciones.usuarioIdCreado=usuarios.id and reservaciones.moneda=monedas.id and reservaciones.tourId=tour.id and reservaciones.tipoTourId=tipo.id and reservaciones.salidaId=lugar_salida.id and reservaciones.nacionalidadId=nacionalidad.id and reservaciones.idiomaId=idioma.id and reservaciones.transporteRegresoId is null and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'" order by reservaciones.cliente ';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
       .then((response)=>{
         if (response.status == 200 ) { console.log("bien jean");
            console.log(response.data,'<-- response php server');
            this.reservacionesRivieraList = response.data;
         }else{
           console.log('error: No reservado');
         }
       });
    },
    
    toursConReservas () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos',
      //     table: "hoteles,areas",
      //     where: 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id',
      //     condition: "order by hoteles.area desc,hoteles.numero asc"
      //   })
      var select = 'tour.*, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.salidaId=1 and reservaciones.tourId=tour.id and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.salidaId=1 and reservaciones.tourId=tour.id and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'") as ninos';
      var tabla = "tour";
      var where = 'tour.id in (select distinct tourId from reservaciones where reservaciones.salidaId=1 and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'") order by tour.id';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.toursReservados = response.data;
          }
        })
    },
    toursConReservasRiviera () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: 'hoteles.*,areas.nombre as areaNombre, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.hotelId=hoteles.id and reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") as ninos',
      //     table: "hoteles,areas",
      //     where: 'hoteles.id in (select distinct hotelId from reservaciones where reservaciones.transporteSalidaId is null and reservaciones.activo=1 and reservaciones.fecha="'+this.fecha+'") and hoteles.area=areas.id',
      //     condition: "order by hoteles.area desc,hoteles.numero asc"
      //   })
      var select = 'tour.*, (select sum(adultos) as adultosTotal from reservaciones where reservaciones.salidaId>1 and reservaciones.tourId=tour.id and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'") as pax, (select sum(ninos) as ninosTotal from reservaciones where reservaciones.salidaId>1 and reservaciones.tourId=tour.id and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'") as ninos';
      var tabla = "tour";
      var where = 'tour.id in (select distinct tourId from reservaciones where reservaciones.salidaId>1 and reservaciones.activo=2 and reservaciones.fecha="'+this.fecha+'") order by tour.id';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.toursReservadosRiviera = response.data;
          }
        })
    },
    getTransportes () {
      // axios.post('http://localhost:3000/justRead', {
      //     select: `*
      //   `,
      //     table: "transportes",
      //     where: 'id not in (SELECT transporteId FROM transportes_utilizados where fecha="'+this.fecha+'") union SELECT transporteId as id,transportes.nombre as nombre, transportes_utilizados.capacidad as capacidad FROM transportes_utilizados,transportes where transportes_utilizados.transporteId=transportes.id and ruta=1 and fecha="'+this.fecha+'" order by id',
      //     condition: ""
      //   })
      var select = '*';
      var tabla = "transportes";
      var where = 'id not in (SELECT transporteId FROM transportes_utilizados where fecha="'+this.fecha+'" and ruta=2 ) union SELECT transporteId as id,transportes.nombre as nombre, transportes_utilizados.capacidad as capacidad FROM transportes_utilizados,transportes where transportes_utilizados.transporteId=transportes.id and ruta=2 and fecha="'+this.fecha+'" order by id';
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response) => {
          if (response.status == 200) {
            this.transportesList = response.data;
          }
        })
    },
  },
  mixins: [searchMix]
}

</script>

<style scoped>
  .borderStyle {
  border-style: solid;
  border-color: #245b8c;
  border-width: 3px!important;
}
td {
  padding: 1px!important;
  }
.tituloHotel {
  background-color:#1E1E1E;
  color: white;
}
.tituloTransporte {
  background-color:#FFC3E5;
}
</style>
<style>

.div{
  padding-top:0px;
  padding-bottom:0px;
  text-align: center;
},
.e1 {
  background-color: #D6FFE6;
}
.e2 {
  background-color: #FFDEDB;
}
.e3 {
  background-color: #AEE2F9;
}
.e4 {
  background-color: #A4A4A5;
}
.e5 {
  background-color: #FFE2FE;
}
.e6 {
  background-color: #F9F9F9;
}
.arrow-up {
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #4c7ca5;
  margin-left:2.5rem;
}
.td:hover {
  background-color: #7aabd6;
}
.tooltip {
  display: block !important;
  z-index: 10000;
  }
.tooltip {
  display: block !important;
  z-index: 10000;
  }
  .tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
  }
  .tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  }
  .tooltip[x-placement^="bottom"] {
  margin-top: 5px;
  }
  .tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
  }
  .tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
  }
  .tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
  }
  table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
    border: 1;
  }
</style>